"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameCountryMap = exports.countryNameMap = exports.CurrencyMap = void 0;
exports.CurrencyMap = {
    Afghanistan: 'USD',
    Albania: 'USD',
    Algeria: 'USD',
    'American Samoa': 'USD',
    Andorra: 'USD',
    Angola: 'USD',
    Anguilla: 'USD',
    Antarctica: 'USD',
    'Antigua and Barbuda': 'USD',
    Argentina: 'USD',
    Armenia: 'USD',
    Aruba: 'USD',
    Australia: 'USD',
    Austria: 'USD',
    Azerbaijan: 'USD',
    'Bahamas (the)': 'USD',
    Bahrain: 'USD',
    Bangladesh: 'USD',
    Barbados: 'USD',
    Belarus: 'USD',
    Belgium: 'USD',
    Belize: 'USD',
    Benin: 'USD',
    Bermuda: 'USD',
    Bhutan: 'USD',
    'Bolivia (Plurinational State of)': 'USD',
    'Bonaire, Sint Eustatius and Saba': 'USD',
    'Bosnia and Herzegovina': 'USD',
    Botswana: 'USD',
    'Bouvet Island': 'USD',
    Brazil: 'USD',
    'British Indian Ocean Territory (the)': 'USD',
    'Brunei Darussalam': 'USD',
    Bulgaria: 'USD',
    'Burkina Faso': 'USD',
    Burundi: 'USD',
    'Cabo Verde': 'USD',
    Cambodia: 'USD',
    Cameroon: 'USD',
    Canada: 'USD',
    'Cayman Islands (the)': 'USD',
    'Central African Republic (the)': 'USD',
    Chad: 'USD',
    Chile: 'USD',
    China: 'USD',
    'Christmas Island': 'USD',
    'Cocos (Keeling) Islands (the)': 'USD',
    Colombia: 'USD',
    'Comoros (the)': 'USD',
    'Congo (the Democratic Republic of the)': 'USD',
    'Congo (the)': 'USD',
    'Cook Islands (the)': 'USD',
    'Costa Rica': 'USD',
    Croatia: 'USD',
    Cuba: 'USD',
    Curaçao: 'USD',
    Cyprus: 'USD',
    Czechia: 'USD',
    "Côte d'Ivoire": 'USD',
    Denmark: 'USD',
    Djibouti: 'USD',
    Dominica: 'USD',
    'Dominican Republic (the)': 'USD',
    Ecuador: 'USD',
    Egypt: 'USD',
    'El Salvador': 'USD',
    'Equatorial Guinea': 'USD',
    Eritrea: 'USD',
    Estonia: 'USD',
    Eswatini: 'USD',
    Ethiopia: 'USD',
    'Falkland Islands (the) [Malvinas]': 'USD',
    'Faroe Islands (the)': 'USD',
    Fiji: 'USD',
    Finland: 'USD',
    France: 'USD',
    'French Guiana': 'USD',
    'French Polynesia': 'USD',
    'French Southern Territories (the)': 'USD',
    Gabon: 'USD',
    'Gambia (the)': 'USD',
    Georgia: 'USD',
    Germany: 'USD',
    Ghana: 'USD',
    Gibraltar: 'USD',
    Greece: 'USD',
    Greenland: 'USD',
    Grenada: 'USD',
    Guadeloupe: 'USD',
    Guam: 'USD',
    Guatemala: 'USD',
    Guernsey: 'USD',
    Guinea: 'USD',
    'Guinea-Bissau': 'USD',
    Guyana: 'USD',
    Haiti: 'USD',
    'Heard Island and McDonald Islands': 'USD',
    'Holy See (the)': 'USD',
    Honduras: 'USD',
    'Hong Kong': 'USD',
    Hungary: 'USD',
    Iceland: 'USD',
    India: 'USD',
    Indonesia: 'USD',
    'Iran (Islamic Republic of)': 'USD',
    Iraq: 'USD',
    Ireland: 'USD',
    'Isle of Man': 'USD',
    Israel: 'USD',
    Italy: 'USD',
    Jamaica: 'USD',
    Japan: 'USD',
    Jersey: 'USD',
    Jordan: 'USD',
    Kazakhstan: 'USD',
    Kenya: 'USD',
    Kiribati: 'USD',
    "Korea (the Democratic People's Republic of)": 'USD',
    'Korea (the Republic of)': 'USD',
    Kuwait: 'USD',
    Kyrgyzstan: 'USD',
    "Lao People's Democratic Republic (the)": 'USD',
    Latvia: 'USD',
    Lebanon: 'USD',
    Lesotho: 'USD',
    Liberia: 'USD',
    Libya: 'USD',
    Liechtenstein: 'USD',
    Lithuania: 'USD',
    Luxembourg: 'USD',
    Macao: 'USD',
    Madagascar: 'USD',
    Malawi: 'USD',
    Malaysia: 'USD',
    Maldives: 'USD',
    Mali: 'USD',
    Malta: 'USD',
    'Marshall Islands (the)': 'USD',
    Martinique: 'USD',
    Mauritania: 'USD',
    Mauritius: 'USD',
    Mayotte: 'USD',
    Mexico: 'USD',
    'Micronesia (Federated States of)': 'USD',
    'Moldova (the Republic of)': 'USD',
    Monaco: 'USD',
    Mongolia: 'USD',
    Montenegro: 'USD',
    Montserrat: 'USD',
    Morocco: 'USD',
    Mozambique: 'USD',
    Myanmar: 'USD',
    Namibia: 'USD',
    Nauru: 'USD',
    Nepal: 'USD',
    'Netherlands (the)': 'USD',
    'New Caledonia': 'USD',
    'New Zealand': 'USD',
    Nicaragua: 'USD',
    'Niger (the)': 'USD',
    Nigeria: 'USD',
    Niue: 'USD',
    'Norfolk Island': 'USD',
    'Northern Mariana Islands (the)': 'USD',
    Norway: 'USD',
    Oman: 'USD',
    Pakistan: 'USD',
    Palau: 'USD',
    'Palestine, State of': 'USD',
    Panama: 'USD',
    'Papua New Guinea': 'USD',
    Paraguay: 'USD',
    Peru: 'USD',
    'Philippines (the)': 'USD',
    Pitcairn: 'USD',
    Poland: 'USD',
    Portugal: 'USD',
    'Puerto Rico': 'USD',
    Qatar: 'USD',
    'Republic of North Macedonia': 'USD',
    Romania: 'USD',
    'Russian Federation (the)': 'USD',
    Rwanda: 'USD',
    Réunion: 'USD',
    'Saint Barthélemy': 'USD',
    'Saint Helena, Ascension and Tristan da Cunha': 'USD',
    'Saint Kitts and Nevis': 'USD',
    'Saint Lucia': 'USD',
    'Saint Martin (French part)': 'USD',
    'Saint Pierre and Miquelon': 'USD',
    'Saint Vincent and the Grenadines': 'USD',
    Samoa: 'USD',
    'San Marino': 'USD',
    'Sao Tome and Principe': 'USD',
    'Saudi Arabia': 'USD',
    Senegal: 'USD',
    Serbia: 'USD',
    Seychelles: 'USD',
    'Sierra Leone': 'USD',
    Singapore: 'USD',
    'Sint Maarten (Dutch part)': 'USD',
    Slovakia: 'USD',
    Slovenia: 'USD',
    'Solomon Islands': 'USD',
    Somalia: 'USD',
    'South Africa': 'USD',
    'South Georgia and the South Sandwich Islands': 'USD',
    'South Sudan': 'USD',
    Spain: 'USD',
    'Sri Lanka': 'USD',
    'Sudan (the)': 'USD',
    Suriname: 'USD',
    'Svalbard and Jan Mayen': 'USD',
    Sweden: 'USD',
    Switzerland: 'USD',
    'Syrian Arab Republic': 'USD',
    'Taiwan (Province of China)': 'USD',
    Tajikistan: 'USD',
    'Tanzania, United Republic of': 'USD',
    Thailand: 'USD',
    'Timor-Leste': 'USD',
    Togo: 'USD',
    Tokelau: 'USD',
    Tonga: 'USD',
    'Trinidad and Tobago': 'USD',
    Tunisia: 'USD',
    Turkey: 'USD',
    Turkmenistan: 'USD',
    'Turks and Caicos Islands (the)': 'USD',
    Tuvalu: 'USD',
    Uganda: 'USD',
    Ukraine: 'USD',
    'United Arab Emirates (the)': 'USD',
    'United Kingdom of Great Britain and Northern Ireland (the)': 'USD',
    'United States Minor Outlying Islands (the)': 'USD',
    'United States of America (the)': 'USD',
    Uruguay: 'USD',
    Uzbekistan: 'USD',
    Vanuatu: 'USD',
    'Venezuela (Bolivarian Republic of)': 'USD',
    'Viet Nam': 'USD',
    'Virgin Islands (British)': 'USD',
    'Virgin Islands (U.S.)': 'USD',
    'Wallis and Futuna': 'USD',
    'Western Sahara': 'USD',
    Yemen: 'USD',
    Zambia: 'USD',
    Zimbabwe: 'USD',
    'Åland Islands': 'USD'
};
exports.countryNameMap = {
    Afghanistan: 'AF',
    Albania: 'AL',
    Algeria: 'DZ',
    'American Samoa': 'AS',
    Andorra: 'AD',
    Angola: 'AO',
    Anguilla: 'AI',
    Antarctica: 'AQ',
    'Antigua and Barbuda': 'AG',
    Argentina: 'AR',
    Armenia: 'AM',
    Aruba: 'AW',
    Australia: 'AU',
    Austria: 'AT',
    Azerbaijan: 'AZ',
    'Bahamas (the)': 'BS',
    Bahrain: 'BH',
    Bangladesh: 'BD',
    Barbados: 'BB',
    Belarus: 'BY',
    Belgium: 'BE',
    Belize: 'BZ',
    Benin: 'BJ',
    Bermuda: 'BM',
    Bhutan: 'BT',
    'Bolivia (Plurinational State of)': 'BO',
    'Bonaire, Sint Eustatius and Saba': 'BQ',
    'Bosnia and Herzegovina': 'BA',
    Botswana: 'BW',
    'Bouvet Island': 'BV',
    Brazil: 'BR',
    'British Indian Ocean Territory (the)': 'IO',
    'Brunei Darussalam': 'BN',
    Bulgaria: 'BG',
    'Burkina Faso': 'BF',
    Burundi: 'BI',
    'Cabo Verde': 'CV',
    Cambodia: 'KH',
    Cameroon: 'CM',
    Canada: 'CA',
    'Cayman Islands (the)': 'KY',
    'Central African Republic (the)': 'CF',
    Chad: 'TD',
    Chile: 'CL',
    China: 'CN',
    'Christmas Island': 'CX',
    'Cocos (Keeling) Islands (the)': 'CC',
    Colombia: 'CO',
    'Comoros (the)': 'KM',
    'Congo (the Democratic Republic of the)': 'CD',
    'Congo (the)': 'CG',
    'Cook Islands (the)': 'CK',
    'Costa Rica': 'CR',
    Croatia: 'HR',
    Cuba: 'CU',
    Curaçao: 'CW',
    Cyprus: 'CY',
    Czechia: 'CZ',
    "Côte d'Ivoire": 'CI',
    Denmark: 'DK',
    Djibouti: 'DJ',
    Dominica: 'DM',
    'Dominican Republic (the)': 'DO',
    Ecuador: 'EC',
    Egypt: 'EG',
    'El Salvador': 'SV',
    'Equatorial Guinea': 'GQ',
    Eritrea: 'ER',
    Estonia: 'EE',
    Eswatini: 'SZ',
    Ethiopia: 'ET',
    'Falkland Islands (the) [Malvinas]': 'FK',
    'Faroe Islands (the)': 'FO',
    Fiji: 'FJ',
    Finland: 'FI',
    France: 'FR',
    'French Guiana': 'GF',
    'French Polynesia': 'PF',
    'French Southern Territories (the)': 'TF',
    Gabon: 'GA',
    'Gambia (the)': 'GM',
    Georgia: 'GE',
    Germany: 'DE',
    Ghana: 'GH',
    Gibraltar: 'GI',
    Greece: 'GR',
    Greenland: 'GL',
    Grenada: 'GD',
    Guadeloupe: 'GP',
    Guam: 'GU',
    Guatemala: 'GT',
    Guernsey: 'GG',
    Guinea: 'GN',
    'Guinea-Bissau': 'GW',
    Guyana: 'GY',
    Haiti: 'HT',
    'Heard Island and McDonald Islands': 'HM',
    'Holy See (the)': 'VA',
    Honduras: 'HN',
    'Hong Kong': 'HK',
    Hungary: 'HU',
    Iceland: 'IS',
    India: 'IN',
    Indonesia: 'ID',
    'Iran (Islamic Republic of)': 'IR',
    Iraq: 'IQ',
    Ireland: 'IE',
    'Isle of Man': 'IM',
    Israel: 'IL',
    Italy: 'IT',
    Jamaica: 'JM',
    Japan: 'JP',
    Jersey: 'JE',
    Jordan: 'JO',
    Kazakhstan: 'KZ',
    Kenya: 'KE',
    Kiribati: 'KI',
    "Korea (the Democratic People's Republic of)": 'KP',
    'Korea (the Republic of)': 'KR',
    Kuwait: 'KW',
    Kyrgyzstan: 'KG',
    "Lao People's Democratic Republic (the)": 'LA',
    Latvia: 'LV',
    Lebanon: 'LB',
    Lesotho: 'LS',
    Liberia: 'LR',
    Libya: 'LY',
    Liechtenstein: 'LI',
    Lithuania: 'LT',
    Luxembourg: 'LU',
    Macao: 'MO',
    Madagascar: 'MG',
    Malawi: 'MW',
    Malaysia: 'MY',
    Maldives: 'MV',
    Mali: 'ML',
    Malta: 'MT',
    'Marshall Islands (the)': 'MH',
    Martinique: 'MQ',
    Mauritania: 'MR',
    Mauritius: 'MU',
    Mayotte: 'YT',
    Mexico: 'MX',
    'Micronesia (Federated States of)': 'FM',
    'Moldova (the Republic of)': 'MD',
    Monaco: 'MC',
    Mongolia: 'MN',
    Montenegro: 'ME',
    Montserrat: 'MS',
    Morocco: 'MA',
    Mozambique: 'MZ',
    Myanmar: 'MM',
    Namibia: 'NA',
    Nauru: 'NR',
    Nepal: 'NP',
    'Netherlands (the)': 'NL',
    'New Caledonia': 'NC',
    'New Zealand': 'NZ',
    Nicaragua: 'NI',
    'Niger (the)': 'NE',
    Nigeria: 'NG',
    Niue: 'NU',
    'Norfolk Island': 'NF',
    'Northern Mariana Islands (the)': 'MP',
    Norway: 'NO',
    Oman: 'OM',
    Pakistan: 'PK',
    Palau: 'PW',
    'Palestine, State of': 'PS',
    Panama: 'PA',
    'Papua New Guinea': 'PG',
    Paraguay: 'PY',
    Peru: 'PE',
    'Philippines (the)': 'PH',
    Pitcairn: 'PN',
    Poland: 'PL',
    Portugal: 'PT',
    'Puerto Rico': 'PR',
    Qatar: 'QA',
    'Republic of North Macedonia': 'MK',
    Romania: 'RO',
    'Russian Federation (the)': 'RU',
    Rwanda: 'RW',
    Réunion: 'RE',
    'Saint Barthélemy': 'BL',
    'Saint Helena, Ascension and Tristan da Cunha': 'SH',
    'Saint Kitts and Nevis': 'KN',
    'Saint Lucia': 'LC',
    'Saint Martin (French part)': 'MF',
    'Saint Pierre and Miquelon': 'PM',
    'Saint Vincent and the Grenadines': 'VC',
    Samoa: 'WS',
    'San Marino': 'SM',
    'Sao Tome and Principe': 'ST',
    'Saudi Arabia': 'SA',
    Senegal: 'SN',
    Serbia: 'RS',
    Seychelles: 'SC',
    'Sierra Leone': 'SL',
    Singapore: 'SG',
    'Sint Maarten (Dutch part)': 'SX',
    Slovakia: 'SK',
    Slovenia: 'SI',
    'Solomon Islands': 'SB',
    Somalia: 'SO',
    'South Africa': 'ZA',
    'South Georgia and the South Sandwich Islands': 'GS',
    'South Sudan': 'SS',
    Spain: 'ES',
    'Sri Lanka': 'LK',
    'Sudan (the)': 'SD',
    Suriname: 'SR',
    'Svalbard and Jan Mayen': 'SJ',
    Sweden: 'SE',
    Switzerland: 'CH',
    'Syrian Arab Republic': 'SY',
    'Taiwan (Province of China)': 'TW',
    Tajikistan: 'TJ',
    'Tanzania, United Republic of': 'TZ',
    Thailand: 'TH',
    'Timor-Leste': 'TL',
    Togo: 'TG',
    Tokelau: 'TK',
    Tonga: 'TO',
    'Trinidad and Tobago': 'TT',
    Tunisia: 'TN',
    Turkey: 'TR',
    Turkmenistan: 'TM',
    'Turks and Caicos Islands (the)': 'TC',
    Tuvalu: 'TV',
    Uganda: 'UG',
    Ukraine: 'UA',
    'United Arab Emirates (the)': 'AE',
    'United Kingdom of Great Britain and Northern Ireland (the)': 'GB',
    'United States Minor Outlying Islands (the)': 'UM',
    'United States of America (the)': 'US',
    Uruguay: 'UY',
    Uzbekistan: 'UZ',
    Vanuatu: 'VU',
    'Venezuela (Bolivarian Republic of)': 'VE',
    'Viet Nam': 'VN',
    'Virgin Islands (British)': 'VG',
    'Virgin Islands (U.S.)': 'VI',
    'Wallis and Futuna': 'WF',
    'Western Sahara': 'EH',
    Yemen: 'YE',
    Zambia: 'ZM',
    Zimbabwe: 'ZW',
    'Åland Islands': 'AX'
};
exports.nameCountryMap = {
    AF: 'Afghanistan',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas (the)',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia (Plurinational State of)',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory (the)',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Cabo Verde',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    KY: 'Cayman Islands (the)',
    CF: 'Central African Republic (the)',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands (the)',
    CO: 'Colombia',
    KM: 'Comoros (the)',
    CD: 'Congo (the Democratic Republic of the)',
    CG: 'Congo (the)',
    CK: 'Cook Islands (the)',
    CR: 'Costa Rica',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Czechia',
    CI: "Côte d'Ivoire",
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic (the)',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    SZ: 'Eswatini',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (the) [Malvinas]',
    FO: 'Faroe Islands (the)',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories (the)',
    GA: 'Gabon',
    GM: 'Gambia (the)',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    VA: 'Holy See (the)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran (Islamic Republic of)',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: "Korea (the Democratic People's Republic of)",
    KR: 'Korea (the Republic of)',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: "Lao People's Democratic Republic (the)",
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands (the)',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia (Federated States of)',
    MD: 'Moldova (the Republic of)',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands (the)',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger (the)',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands (the)',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine, State of',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines (the)',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    MK: 'Republic of North Macedonia',
    RO: 'Romania',
    RU: 'Russian Federation (the)',
    RW: 'Rwanda',
    RE: 'Réunion',
    BL: 'Saint Barthélemy',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin (French part)',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Dutch part)',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan (the)',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan (Province of China)',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands (the)',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates (the)',
    GB: 'United Kingdom of Great Britain and Northern Ireland (the)',
    UM: 'United States Minor Outlying Islands (the)',
    US: 'United States of America (the)',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela (Bolivarian Republic of)',
    VN: 'Viet Nam',
    VG: 'Virgin Islands (British)',
    VI: 'Virgin Islands (U.S.)',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    AX: 'Åland Islands'
};
